import { styled } from '@mui/material/styles';
import { Box } from '@mui/material';

export const PrintContainer = styled(Box)({
  padding: '20px',
  backgroundColor: '#fff',
  '@media print': {
    padding: '0',
  }
});

export const ItineraryTable = styled('table')({
  width: '100%',
  borderCollapse: 'collapse',
  '& th, & td': {
    padding: '2px 10px',
    border: '1px solid #dee2e6',
    borderTop: 'none',
    borderBottom: 'none'
  },
  '& th': {
    backgroundColor: '#f8f9fa',
    borderTop: '1px solid #000',
    borderBottom: '1px solid #000'
  },
  '& tr.day-separator td': {
    borderBottom: '1px solid #000'
  }
}); 